var React = require('react');

function ArrowDown (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M6.5 10L0.870835 0.25L12.1292 0.249999L6.5 10Z","fill":"#E4E4E4"}));
}

ArrowDown.defaultProps = {"width":"13","height":"10","viewBox":"0 0 13 10","fill":"none"};

module.exports = ArrowDown;

ArrowDown.default = ArrowDown;
